var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_13287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40781 13.2879C6.80663 13.0878 7.05838 12.6808 7.05838 12.2349V9.88196H18.8232C19.4726 9.88196 19.9996 9.35608 19.9996 8.7055C19.9996 8.05493 19.4726 7.52905 18.8232 7.52905L7.05843 7.52905V5.17608C7.05843 4.73021 6.80669 4.32311 6.40786 4.12315C6.00904 3.9255 5.53256 3.96785 5.17609 4.23493L0.470207 7.76436C0.450188 7.77964 0.443129 7.80318 0.424324 7.81967C0.332558 7.89732 0.261971 7.98909 0.197283 8.09144C0.171417 8.13379 0.137281 8.16672 0.116104 8.2126C0.0455151 8.36321 -0.000366211 8.52788 -0.000366211 8.70556C-0.000366211 8.88324 0.0455151 9.04791 0.116104 9.19968C0.137281 9.2444 0.171417 9.27848 0.197283 9.31968C0.261971 9.42203 0.332558 9.5138 0.424324 9.59145C0.443129 9.60672 0.450188 9.63143 0.470207 9.64676L5.17609 13.1762C5.53251 13.4444 6.00898 13.4867 6.40781 13.2879Z",
    fill: "#7E8C9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_13287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.9ecd6bd3f82c565083aea8c91c4f41ee.svg";
export { ForwardRef as ReactComponent };